/**
 * Utility functions for extracting event type data
 * Shared between EventCard and EventDetail components
 */

import type { Event } from '../types';

export interface EventTypeData {
  eventTypeColor?: string;
  firstEventType: { id: string; name: string } | null;
}

/**
 * Extract event type data from an Event object
 * Handles both single eventType objects and arrays
 * Only TermEventType has eventTypeColor property
 */
export function extractEventTypeData(event: Event): EventTypeData {
  // eventType can be either a single object or an array depending on GraphQL fragment
  const eventTypeArray = Array.isArray(event.eventType)
    ? event.eventType
    : event.eventType
      ? [event.eventType]
      : [];
  const firstEventTypeItem = eventTypeArray[0];

  // Only TermEventType has eventTypeColor property
  // Check __typename first, then fallback to property check
  const isTermEventType = 
    firstEventTypeItem?.__typename === 'TermEventType' ||
    (firstEventTypeItem && 'eventTypeColor' in firstEventTypeItem);
  
  const eventTypeColor = isTermEventType && firstEventTypeItem && 'eventTypeColor' in firstEventTypeItem
    ? (firstEventTypeItem.eventTypeColor ?? undefined)
    : undefined;

  const firstEventType =
    firstEventTypeItem && firstEventTypeItem.id && firstEventTypeItem.name
      ? { id: firstEventTypeItem.id, name: firstEventTypeItem.name }
      : null;

  return {
    eventTypeColor,
    firstEventType,
  };
}

